import { render, staticRenderFns } from "./BasicInformation.vue?vue&type=template&id=26d7db8e&scoped=true"
import script from "./BasicInformation.vue?vue&type=script&lang=js"
export * from "./BasicInformation.vue?vue&type=script&lang=js"
import style0 from "./BasicInformation.vue?vue&type=style&index=0&id=26d7db8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d7db8e",
  null
  
)

export default component.exports